import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import ContactUs from 'src/components/Footer/ContactUs';
import InfoLinks from 'src/components/Footer/InfoLinks';
import SocialLinks from 'src/components/Footer/SocialLinks';
import TaxLinks from 'src/components/Footer/TaxLinks';
import ApplicationDownloadButtons from 'src/components/Steps/ApplicationDownloadButtons';
import { SvgImage } from 'src/helpers';
import {
  Container,
  DownloadLinksWrapper,
  FooterBlock,
  FooterContainer,
  Info,
  JonniLogoDesktop,
  JonniLogoMobile,
  StyledDiv,
} from 'src/styles/footer';

export const LinkStyle = { textDecoration: 'none', color: '#FFF' };

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  const {
    allContentfulFooter: { edges },
  } = useStaticQuery(graphql`
    query FooterQuery {
      allContentfulFooter {
        edges {
          node {
            jonniLogo {
              svg {
                content: originalContent
              }
              file {
                contentType
              }
            }
            taxAuthorityIcon {
              svg {
                content: originalContent
              }
              file {
                contentType
              }
            }
            privacyAuthorityIcon {
              svg {
                content: originalContent
              }
              file {
                contentType
              }
            }
          }
        }
      }
    }
  `);

  const { jonniLogo, taxAuthorityIcon, privacyAuthorityIcon } = edges[0].node;

  return (
    <>
      <ContactUs />
      <FooterContainer>
        <StyledDiv>
          <JonniLogoMobile>
            <SvgImage {...jonniLogo} />
            <Info> JONNIX Ltd © {new Date().getFullYear()}</Info>
          </JonniLogoMobile>
          <DownloadLinksWrapper>
            <ApplicationDownloadButtons />
          </DownloadLinksWrapper>
          <Container>
            <FooterBlock>
              <JonniLogoDesktop>
                <SvgImage {...jonniLogo} />
                <Info> JONNIX Ltd © {new Date().getFullYear()}</Info>
              </JonniLogoDesktop>
              <TaxLinks privacyAuthorityIcon={privacyAuthorityIcon} taxAuthorityIcon={taxAuthorityIcon} />
              <InfoLinks />
              <SocialLinks />
            </FooterBlock>
          </Container>
        </StyledDiv>
      </FooterContainer>
    </>
  );
};

export default Footer;
